class ImageMenu2 {

  elements = {};

  constructor(wrapper) {
    if (wrapper.data('initialized')) {
      return;
    }

    this.loadElements(wrapper);
    this.applySlider();

    wrapper.data('initialized', true);
  }

  loadElements(wrapper) {
    this.elements.wrapper = wrapper;
    this.elements.images = wrapper.find('.image-menu-2__images');
  }

  applySlider() {
    this.elements.images.slick(
      {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }
    );
  }
}

jQuery(document).ready(
  () => {
    // Initialize wrappers
    const wrappers = jQuery('.image-menu-2__wrapper');
    wrappers.each(
      (index) => {
        new ImageMenu2(wrappers.eq(index));
      }
    );

    // Set up MutationObserver to watch for new wrappers
    const observer = new MutationObserver(
      (mutations) => {
        mutations.forEach(
          (mutation) => {
            mutation.addedNodes.forEach(
              (node) => {
                // Check if the added node is an element
                if (node.nodeType !== Node.ELEMENT_NODE) {
                  return;
                }

                const nodeElement = jQuery(node);

                // Check if the node itself is a wrapper
                if (nodeElement.hasClass('image-menu-2__wrapper')) {
                  new ImageMenu2(nodeElement);
                }

                // Check for wrapper elements within the added node
                const wrappers = nodeElement.find('.image-menu-2__wrapper');
                wrappers.each(
                  (index) => {
                    new ImageMenu2(wrappers.eq(index));
                  }
                );
              }
            );
          }
        );
      }
    );

    // Start observing the document for changes
    observer.observe(
      document.body, {
        childList: true,
        subtree: true
      }
    );
  }
);
